import React, { useCallback, useEffect, useState } from "react";
import style from "css/mypage.module.css";
import FavoritePop from "components/mypagecomponents/favoritePop";
import axios from "axios";
import Favoritecard from "components/mypagecomponents/favoritecard";
import ResPop from "components/menu/resPop";
import { Button, Input, Spin } from "antd";
import Searchbox from "components/mypagecomponents/searchbox";
import { useTranslation } from "react-i18next";

function Favorite() {
  const { t } = useTranslation();
  const [IsHover, setIsHover] = useState(false);
  const [loading, setLoading] = useState(true);

  const [scheduleType, setScheduleType] = useState("");
  const getSystemType = useCallback(() => {
    axios
      .get("/schedule/systemInfo")
      .then((res) => {
        if (res.status === 200) {
          setScheduleType(res.data.SYSTEM_TYPE);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    getSystemType();
  }, [getSystemType]);

  const [schedule, setSchedule] = useState({
    PROCESS_TYPE: "C",
    TITLE: "",
    CONTENTS: "",
    SCHEDULE_TYPE: scheduleType,
    OPEN_YN: "Y",
    RECORD_YN: "N",
    MAIL_YN: "Y",
    MEETING_PW: "",
    PARTICIPANT_LIST: [],
    ENDPOINT_LIST: [],
    ATTACHMENT_LIST: [],
  });

  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }
  const [search, setsearch] = useState(true);

  const [favoritelist, setfavoritelist] = useState([]);
  useEffect(() => {
    if (search) {
      setLoading(true);
      let config = {
        params: {
          KEY_WORD: keyword,
        },
      };

      axios
        .get("/schedule/favorites", config)
        .then((res) => {
          if (res.status === 200) {
            setfavoritelist(res.data);
          }
        })
        .finally(() => {
          setsearch(false);
          setLoading(false);
        });
    }
  }, [search]);

  const searchbutton = () => {
    setsearch(true);
    setSchedule({
      PROCESS_TYPE: "C",
      TITLE: "",
      CONTENTS: "",
      SCHEDULE_TYPE: scheduleType,
      OPEN_YN: "Y",
      RECORD_YN: "N",
      MEETING_PW: "",
      PARTICIPANT_LIST: [],
      ENDPOINT_LIST: [],
      PASS_YN: false,
      MAIL_YN: "N",
      ATTACHMENT_LIST: [],
    });
  };
  const [isOpenRes, setIsOpenRes] = useState(false);
  const openRes = () => {
    setSchedule({
      PROCESS_TYPE: "C",
      TITLE: "",
      CONTENTS: "",
      SCHEDULE_TYPE: scheduleType,
      OPEN_YN: "Y",
      RECORD_YN: "N",
      MEETING_PW: "",
      PARTICIPANT_LIST: [],
      ENDPOINT_LIST: [],
      PASS_YN: false,
      MAIL_YN: "N",
      ATTACHMENT_LIST: [],
    });
    setIsOpenRes(true);
  };

  const openResU = (data) => {
    if (data.PW_YN === "Y") {
      setSchedule({
        PROCESS_TYPE: "U",
        TITLE: data.TITLE,
        CONTENTS: data.CONTENTS,
        SCHEDULE_TYPE: scheduleType,
        OPEN_YN: data.OPEN_YN,
        RECORD_YN: data.RECORD_YN,
        MEETING_PW: data.MEETING_PW,
        PARTICIPANT_LIST: data.PARTICIPANTS,
        ENDPOINT_LIST: data.ENDPOINT_LIST,
        PASS_YN: true,
        FAVORITES_ID: data.FAVORITES_ID,
        MAIL_YN: data.MAIL_YN,
        ATTACHMENT_LIST: data.ATTACHMENT_LIST,
      });
    } else {
      setSchedule({
        PROCESS_TYPE: "U",
        TITLE: data.TITLE,
        CONTENTS: data.CONTENTS,
        SCHEDULE_TYPE: scheduleType,
        OPEN_YN: data.OPEN_YN,
        RECORD_YN: data.RECORD_YN,
        MEETING_PW: data.MEETING_PW,
        PARTICIPANT_LIST: data.PARTICIPANTS,
        ENDPOINT_LIST: data.ENDPOINT_LIST,
        PASS_YN: false,
        FAVORITES_ID: data.FAVORITES_ID,
        MAIL_YN: data.MAIL_YN,
        ATTACHMENT_LIST: data.ATTACHMENT_LIST,
      });
    }
    setSchedulemake({
      PROCESS_TYPE: "C",
      TITLE: data.TITLE,
      CONTENTS: data.CONTENTS,
      SCHEDULE_TYPE: scheduleType,
      START_TIME: getReserveDateTime(new Date(), 0),
      END_TIME: getReserveDateTime(new Date(), 30),
      OPEN_YN: data.OPEN_YN,
      RECORD_YN: data.RECORD_YN,
      MEETING_PW: data.MEETING_PW,
      MAIL_YN: data.MAIL_YN,
      PARTICIPANT_LIST: data.PARTICIPANTS,
      ENDPOINT_LIST: data.ENDPOINT_LIST,
      ATTACHMENT_LIST: data.ATTACHMENT_LIST,
    });

    setIsOpenRes(true);
  };
  const closeRes = () => {
    setIsOpenRes(false);
  };

  const makeschedule = () => {
    setIsOpenRes(false);
    setIsOpenResC(true);
  };

  const [isOpenResC, setIsOpenResC] = useState(false);
  const closeResC = () => {
    setIsOpenResC(false);
  };
  const [schedulemake, setSchedulemake] = useState({
    PROCESS_TYPE: "C",
    TITLE: "",
    CONTENTS: "",
    SCHEDULE_TYPE: scheduleType,
    START_TIME: getReserveDateTime(new Date(), 0),
    END_TIME: getReserveDateTime(new Date(), 30),
    OPEN_YN: "Y",
    RECORD_YN: "N",
    MEETING_PW: "",
    PARTICIPANT_LIST: [],
    ENDPOINT_LIST: [],
    MAIL_YN: "N",
    ATTACHMENT_LIST: [],
  });
  const [keyword, setkeyword] = useState("");
  const onchagekeywords = (e) => {
    setkeyword(e.target.value);
  };
  const [searchset, setsearchset] = useState(true);
  const searchOn = (data) => {
    setkeyword(data);
    setsearch(true);
  };
  return (
    <div className={style.mypage_body}>
      <FavoritePop
        isOpenRes={isOpenRes}
        close={closeRes}
        makenew={makeschedule}
        setSchedule={(data) => setSchedule(data)}
        schedule={schedule}
        getScheduleList={() => searchbutton()}
      />
      <ResPop
        isOpenRes={isOpenResC}
        close={closeResC}
        setSchedule={(data) => setSchedulemake(data)}
        schedule={schedulemake}
        getScheduleList={() => searchbutton()}
      />
      <div className={style.searchline}>
        <div>
          <Searchbox
            search={(data) => searchOn(data)}
            data={favoritelist}
            searchset={searchset}
            setsearchset={() => setsearchset(false)}
            type="common"
          />
        </div>
        <div className={style.viewtypes}></div>
      </div>
      <div className={style.favoritebody}>
        {!loading ? (
          <div className={style.itemlist}>
            <div
              className={
                IsHover
                  ? style.itmebox_favorite_hover + " cursor"
                  : style.itmebox_favorite + " cursor"
              }
              onMouseOver={() => setIsHover(true)}
              onMouseOut={() => setIsHover(false)}
              onClick={() => openRes()}
            >
              {/* {duration(today, props.data.START_DATETIME)} */}

              <div className={style.makefavorite}>
                <div className={style.makemark}>
                  <img
                    alt="plus-circle"
                    src={
                      process.env.REACT_APP_CLIENT_URL +
                      "img/mypage/plus-circle.png"
                    }
                  />
                </div>
                <div
                  className={
                    IsHover
                      ? style.itmebox_favorite_make_hover + " cursor"
                      : style.itmebox_favorite_make + " cursor"
                  }
                >
                  {t("LABEL.TITLE.CREATE_FAVORITE_MEETING_CARD")}
                </div>
              </div>

              <div className={style.itembox_footer}></div>
            </div>
            {favoritelist.length > 0 ? (
              favoritelist.map((data, index) => (
                <Favoritecard
                  data={data}
                  key={index}
                  openpop={(data) => openResU(data)}
                  getScheduleList={() => searchbutton()}
                />
              ))
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <div className="spin-container">
            <Spin />
          </div>
        )}
      </div>
    </div>
  );
}

export default Favorite;
